import { render, staticRenderFns } from "./UIShareBtn.vue?vue&type=template&id=44b849aa&"
import script from "./UIShareBtn.vue?vue&type=script&lang=ts&"
export * from "./UIShareBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports